import AppProvider from 'App/AppProviders'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'

ReactDOM.render(<AppProvider />, document.getElementById('root'))
